import { authService } from '../services/api';

const PrivateRoute = ({ children }) => {
  const isAuthenticated = authService.isAuthenticated();
  const tenantCodigo = localStorage.getItem('tenant_codigo');

  if (!isAuthenticated) {
    // Si hay un tenant_codigo, redirigir al login del tenant
    if (tenantCodigo) {
      window.location.href = `/${tenantCodigo}/login`;
    } else {
      window.location.href = '/login';
    }
    return null;
  }

  return children;
};

export default PrivateRoute;